import React from 'react'
import './styles.scss'

import icon_addText from '../../i/add_text.svg'
import icon_addImg from '../../i/add_img.svg'
import icon_addFlip from '../../i/add_flip.svg'
import icon_addEmbed from '../../i/add_embed.svg'
import icon_addVideo from '../../i/add_video.svg'
import icon_addCta from '../../i/add_cta.svg'
import icon_addZoomMap from '../../i/add_zoom_map.svg'
import icon_addFindAndShow from '../../i/add_find_and_show.svg'

const BLOCKS = [
    { t: 1, icon: icon_addText, label: 'Add text' },
    { t: 2, icon: icon_addImg, label: 'Add image' },
    { t: 4, icon: icon_addFlip, label: 'Add Flip' },
    { t: 3, icon: icon_addEmbed, label: 'Embed Interacty project' },
    { t: 5, icon: icon_addVideo, label: 'Embed Youtube video' },
    { t: 6, icon: icon_addCta, label: 'CTA button' },
    { t: 7, icon: icon_addZoomMap, label: 'Zoom map' },
    { t: 8, icon: icon_addFindAndShow, label: 'Find and show' },
]

class BlocksPane extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.onClick = this.onClick.bind(this)
        this.onClose = this.onClose.bind(this)
    }

    onClick(evt) {
        const { onAdd, insertBeforeId } = this.props

        if (onAdd) {
            const t = evt.currentTarget.getAttribute('datat')
            if (t) {
                onAdd(parseInt(t), insertBeforeId)
            } else {
                console.error(`Unsupported block type`, t)
            }
        }
    }

    onClose() {
        this.props.onClose()
    }

    render() {
        const { open } = this.props
        return (
            <div className={`settings_panel control_pane blockpane ${open ? '' : '__hidden'}`}>
                <h2>All blocks</h2>
                {BLOCKS &&
                    BLOCKS.map(b => {
                        return (
                            <div key={b.t} className="block_item" datat={b.t} onClick={this.onClick}>
                                {b.icon ? <img src={b.icon}></img> : null}
                                <p>{b.label}</p>
                            </div>
                        )
                    })}
                <div className="close" onClick={this.onClose}></div>
            </div>
        )
    }
}

export default BlocksPane
